export * from './style.component';
export * from './style-new.component'
export * from './style-edit.component'
export * from './style-upload.component'
export * from './style-preview-form.component'
